<template>
  <content-panel>
    <!--搜索-->
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" ref="searchForm">
          <el-form-item label="产品编码" prop="productCode">
            <el-input v-model="searchForm.productCode" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <el-input v-model="searchForm.productName" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="大型号" prop="bigModel">
            <el-input v-model="searchForm.bigModel" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearchList">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>

    <!--列表-->
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" class="green-btn" @click="exportExcel" style="margin-left: 10px">导出 </el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            <template v-if="item.columnName == 'picNumBig'">
              <el-link type="primary" :underline="false" @click="videoShow(scope.row, 1, scope.row.picNumBig)">{{ scope.row.picNumBig }}</el-link>
            </template>
            <template v-else-if="item.columnName == 'picNumSpecial'">
              <el-link type="primary" :underline="false" @click="videoShow(scope.row, 2, scope.row.picNumSpecial)">{{ scope.row.picNumSpecial }}</el-link>
            </template>
            <template v-else-if="item.columnName == 'picNumBottom'">
              <el-link type="primary" :underline="false" @click="videoShow(scope.row, 3, scope.row.picNumBottom)">{{ scope.row.picNumBottom }}</el-link>
            </template>
            <template v-else-if="item.columnName == 'picNumSmall'">
              <el-link type="primary" :underline="false" @click="videoShow(scope.row, 4, scope.row.picNumSmall)">{{ scope.row.picNumSmall }}</el-link>
            </template>
            <template v-else-if="item.columnName == 'picNumChannel'">
              <el-link type="primary" :underline="false" @click="videoShow(scope.row, 5, scope.row.picNumChannel)">{{ scope.row.picNumChannel }}</el-link>
            </template>
            <template v-else>
              {{ scope.row[item.columnName] | cellValFormat }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <el-dialog :title="dialogTitle" :visible.sync="imgFormVisible" :close-on-click-modal="false" @cancel="updateVal" @close="updateVal" width="1150px">
      <imgShow
        :dialogTitle="dialogTitle"
        :rowData="rowData"
        ref="imgShow"
        v-if="imgFormVisible"
      >
      </imgShow>
      <div class="no-data" style="text-align: center; color: #999999" v-else>暂无数据</div>
    </el-dialog>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import imgShow from "./common/imgShow.vue";
import axios from "@/utils/axiosInstance";
export default {
  name: "videoFullPlatform",
  components: { imgShow },
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      // tableHeight: null,
      loading: false,
      loading2: false,
      searchForm: {
        productCode: "",
        productName: "",
        bigModel: "",
      },
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogTableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      reportName: 'newProductPictureSumInfo',
      model: [],
      columnData: [],
      rowData: {},
      searchFormData: {},
      dialogVisibleDownload: false,
      jurisdiction: false,
      useObjectList: [],
      downloadTextData: [],
      imgList: [],
      imgFormVisible: false,
      dialogTitle: "大片",
      dialogText: {},
      imgForm: {},
      imgTitleList: [],
      imgTitle: "",
      categorys: [],
      queryCriteria: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.init();
      });
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "productCode", //产品编码
          val: this.searchForm.productCode ? this.searchForm.productCode : "",
          op: "=",
        },
        {
          attributeName: "productName", //产品名称
          val: this.searchForm.productName ? this.searchForm.productName : "",
          op: "like",
        },
        {
          attributeName: "bigModel", //大型号
          val: this.searchForm.bigModel ? this.searchForm.bigModel : "",
          op: "like",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    updateVal() {
      this.$refs.imgShow.checkedCities = [];
    },
    videoShow(row, index, data) {
      if(!data) return
      this.dialogTitle = index == 1 ? "大片" : index == 2 ? "特写" : index == 3 ? "退底" : index == 4 ? "小片" : "通道";
      this.rowData = {...row}
      this.imgFormVisible = true;
    },
    onSearchList() {
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != "图片"); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "-";
        }
      }
    },
  },

  mounted() {
    this.columns();
  },
};
</script>

<style lang="stylus" scoped>
</style>
